import { render, staticRenderFns } from "./l12index.vue?vue&type=template&id=70139c00&scoped=true&"
import script from "./l12index.vue?vue&type=script&lang=js&"
export * from "./l12index.vue?vue&type=script&lang=js&"
import style0 from "./l12index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./l12index.vue?vue&type=style&index=1&id=70139c00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70139c00",
  null
  
)

export default component.exports